import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Waves } from "lucide-react";

const BOOK_URL = "https://portal.pivot1st.co.uk/book/2/class";

export default function FinalCTA() {
  return (
    <section className="pt-24 md:pt-32 pb-24 md:pb-28" data-testid="final-cta-section">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-[2.5rem] bg-[#0A2540] px-8 py-16 md:px-16 md:py-24 text-center"
        >
          <div className="blob absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[#0EA5E9]/20" />
          <div className="blob absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-[#FF7A1A]/20" />
          <div className="relative">
            <span className="inline-flex items-center gap-2 text-sm text-[#38BDF8] tracking-[0.2em] uppercase font-bold">
              <Waves size={16} /> Ready to begin?
            </span>
            <h2 className="mt-5 font-heading text-3xl md:text-5xl font-bold tracking-tight text-white leading-tight max-w-3xl mx-auto">
              Join families who trust Happy Tiddlers to raise confident swimmers for life
            </h2>
            <div className="mt-10 flex flex-wrap gap-4 justify-center">
              <a
                href={BOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#FF7A1A] text-white font-bold px-8 py-4 rounded-full shadow-[0_8px_20px_-6px_rgba(255,122,26,0.6)] hover:-translate-y-1 transition-all duration-300"
                data-testid="final-book-cta"
              >
                Book now
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-white/10 text-white font-bold px-8 py-4 rounded-full border border-white/20 hover:bg-white/20 transition-all duration-300"
                data-testid="final-help-cta"
              >
                Get help choosing a class <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
